import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/entities/user';
import { PlatformApi } from '@/lib/api/platform/platformSdk';

const TWENTY_MINUTES = 20 * 60 * 1000;

export function useUserOrganizations() {
  const { email, organization } = useAuth((s) => ({
    email: s.signedInUser.value?.email,
    organization: s.signedInUser.value?.organization,
  }));

  const query = useQuery({
    queryKey: ['user-organizations', email],
    queryFn: async () => {
      const response = await PlatformApi.searchOrganizationsByEmail(email ?? '');
      return response.data.data;
    },
    enabled: !!email,
    staleTime: TWENTY_MINUTES,
    refetchOnWindowFocus: false,
  });

  const hasMultipleOrganizations = (query.data?.length ?? 0) > 1;

  // Return the query under a stable key + only the fields callers consume,
  // instead of spreading. Spreading observes ALL query fields and causes the
  // hook to re-render on every internal TanStack Query state change (per
  // `@tanstack/query/no-rest-destructuring`).
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    assignedOrganization: organization,
    hasMultipleOrganizations,
  };
}
